import React from "react";
import styled from "styled-components";
import ChevronLeftRounded from "@material-ui/icons/ChevronLeftRounded";
import ChevronRightRounded from "@material-ui/icons/ChevronRightRounded";
import moment from "moment";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { colors } from "@sonder/ui/source/styled/theme";

const StyledPreviousMonthButton = styled(Button)`
  left: 1.3rem;
  position: absolute;
  top: 1rem;
`;
const StyledNextMonthButton = styled(Button)`
  position: absolute;
  right: 1.3rem;
  top: 1rem;
`;

const StyledMonthHeader = styled.div`
  color: ${colors.blue2};
  line-height: 1.5rem;
`;

interface MonthElementProps {
  month: moment.Moment;
  onMonthSelect: (currentMonth: moment.Moment, newMonthVal: string) => void;
  onYearSelect: (currentMonth: moment.Moment, newYearVal: string) => void;
}
export const MonthElement = ({ month }: MonthElementProps) => (
  <StyledMonthHeader>{month.format("MMMM YYYY")}</StyledMonthHeader>
);

export const PreviousMonthButton = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement>,
) => (
  <StyledPreviousMonthButton {...props}>
    <ChevronLeftRounded />
  </StyledPreviousMonthButton>
);

export const NextMonthButton = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement>,
) => (
  <StyledNextMonthButton {...props}>
    <ChevronRightRounded />
  </StyledNextMonthButton>
);
